export default `
# Binary Search Tree
## Introduction
A [Binary Search Tree](https://en.wikipedia.org/wiki/Binary_search_tree) is a node-based binary tree data structure which has the following properties:
- The left subtree of a node contains only nodes with keys lesser than the node’s key.
- The right subtree of a node contains only nodes with keys greater than the node’s key.
- The left and right subtree each must also be a binary search tree.
- There must be no duplicate nodes.

`;
